import React from 'react'
import PokerTableCard from './PokerTableCard'

// onRemove is optional: the master's view passes it (shows the × button),
// the participant's own view doesn't (no button, just the card + name).
const PokerSeat = ({ participant, revealed, onRemove }) => (
  <div className="poker-seat">
    {onRemove && (
      <button
        type="button"
        className="poker-seat-remove"
        onClick={() => onRemove(participant.id, participant.name)}
        aria-label={`Excluir ${participant.name}`}
      >
        ×
      </button>
    )}
    <PokerTableCard voted={participant.voted} revealed={revealed} vote={participant.vote} />
    <span className="poker-seat-name">{participant.name}</span>
  </div>
)

export default PokerSeat
